import { updateBreadcrumbs } from '../../app/actions/UpdateBreadcrumbsAction';
import { appStore } from '../../app/AppStore';
import { BreadcrumbStateInfo } from '../../app/content/breadcrumbs/BreadcrumbStateInfo';
import { EditableUserProfilePicture } from '../../app/content/EditableUserProfilePicture';
import { IMainScope } from '../../app/IMainScope';
import { imgUrl } from '../../common/utilities/ImgUrl';
import { IUserSettings } from '../models/IUserSettings';
import { Module } from '../Module';
import { IServerUser } from '../ServerApi/types/IServerUser';
import { ProfilePictureService } from '../services/ProfilePictureService';
import { IToastOptions, ToasterService, ToastType } from '../services/ToasterService';
import { getServerUsersPlaceBreadcrumb } from './ServerUsersPlaceCtrl';

// To be deleted with featureFlags.stylishServerUser (with ServerUserPlace.pug)

export interface IServerUserPlaceScope extends IMainScope {
  serverUser: IServerUser;
  profilePictureProps: EditableUserProfilePicture.Props;
  userSettings: IUserSettings;
  userImageUrl: string;
}

export class ServerUserPlaceCtrl {

  public static $inject = [
    '$scope',
    'serverUser',
    'userSettings',
    'ToasterService',
    'ProfilePictureService'
  ];

  constructor(
    $scope: IServerUserPlaceScope,
    serverUser: IServerUser,
    userSettings: IUserSettings,
    toaster: ToasterService,
    profilePictureService: ProfilePictureService
  ) {
    const breadcrumbs: BreadcrumbStateInfo[] =  [
      getServerUsersPlaceBreadcrumb(),
      { text: serverUser.displayName }
    ];

    appStore.dispatch(updateBreadcrumbs(breadcrumbs));

    $scope.serverUser = serverUser;
    $scope.userSettings = userSettings;

    if (serverUser.userImageUrl) {
      $scope.userImageUrl = 'url(' + serverUser.userImageUrl + ')';
    } else {
      $scope.userImageUrl = imgUrl('user_content_type.svg');
    }

    $scope.profilePictureProps = {
      profileDisplayName: serverUser.displayName,
      imageUrl: serverUser.userImageUrl,
      allowEdit: true,
      imageValidator: (imageFile: File, callback: (isValidImage: boolean) => void) => {
        const errorMessage: string = profilePictureService.validateImage(imageFile);
        if (errorMessage) {
          showToasterWarningOrReload ({
            type: ToastType.Error,
            text: errorMessage,
          });
        }
        callback(!errorMessage);
      },
      handleSubmit: (newUserImage: Blob) => {
        profilePictureService.handlePictureSubmit(serverUser.domainName, serverUser.username,
          newUserImage, (toasterConfig) => showToasterWarningOrReload(toasterConfig));
      }
    };

    function showToasterWarningOrReload(toasterConfig: IToastOptions) {
      if (toasterConfig) {
        toaster.pop(toasterConfig);
      } else {
        location.reload();
      }
    }

  }
}

Module.instance().controller('ServerUserPlaceCtrl', ServerUserPlaceCtrl);
